import React from "react";
import {
  TextField,
  Grid,
  InputLabel,
  Select,
  MenuItem,
  DialogActions,
} from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
// import { TextField } from '@mui/material';
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import axios from "axios";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { yupResolver } from "@hookform/resolvers/yup";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

import { Dialog, DialogContent, Icon, Toolbar } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import HomeIcon from "@mui/icons-material/Home";

import { NewVariety } from "../../../Validation";
import FormControl from "@mui/material/FormControl";
import { Box } from "react-bootstrap-icons";
import ComponentLoader from "../../../../ComponentLoader";

function B5Inside({ head }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = React.useState(false);

  const [Studentbtn, setStudentbtn] = useState([]);

  const [dropdown, setDropdown] = useState([]);
  const [depatId, setDepatId] = useState(null);
  const [PType, setPType] = useState([]);
  const [depatIdProductType, setDepatIdProductType] = useState("");
  const [realeaseType, setRealeaseType] = useState("");
  const [RType, setRType] = useState([]);

  const [productType, setProductType] = useState("");
  const [productName, setProductName] = useState("");
  const [prodcutSpecialFeature, setProdcutSpecialFeature] = useState("");
  const [loader,setLoader] =useState(true);
  const [depatIdErr,setdepatIdErr] = useState(false)
  const [productTypeErr,setproductTypeErr] = useState(false)
  const [productNameErr,setProductNameErr] = useState(false)
  const [realeaseTypeErr,setrealeaseTypeErr] = useState(false)
  const [prodcutSpecialFeatureErr,setProdcutSpecialFeatureErr] = useState(false)



  const [state, setState] = useState();
  const [assM, setAssMonth] = useState("");
  const [invis, setInvestigator] = useState();

  const [token, setToken] = useState("");
  const [id, setId] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();

  const toastSuccess = (data) => {
    toast.success(data, {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    setValue,
    reset,
    watch,
  } = useForm({
    resolver: yupResolver(NewVariety),
  });

  useEffect(() => {
    const tok = localStorage.getItem("token");
    setToken(tok);
    console.log(tok);
    if (tok != null && tok != undefined) {
      // handleDirectorate(tok);
      handleDropdown(tok);
      handleLovType(tok);
      handleReleseLovType(tok);
      console.log(location.state);
      if (location.state) {
        edit(location.state);
      }
    }
    head("New Variety Product");
  }, []);

  useEffect(() => {
    const objectString = localStorage.getItem("MReport");
    const myObject = JSON.parse(objectString);
    if (myObject !== null) {
      setState(myObject);
    }
    const Month = localStorage.getItem("Month");
    if (Month !== null) {
      setAssMonth(Month);
    }
    const investigator = localStorage.getItem("loginId");
    setInvestigator(investigator);
  }, []);

  const handleBack = () => {
    navigate("/B5");
  };

  const edit = (item) => {
    console.log(item);
    setDepatId(item.depatId)
    setProductType(item.productType)
    setProductName(item.productName)
    setRealeaseType(item.realeaseType)
    setProdcutSpecialFeature(item.prodcutSpecialFeature)
    setId(item.id);
  };

  // const SubmitBtn = () => {
  //   alert("Succesfully Submitted");
  // };

  console.log(errors);

  const handleClickOpen = () => {
    setOpen(true);
    //  navigate("/Activities")
  };

  const handleClose = () => {
    setOpen(false);
    // setId(0)
  };

  // DeptId Dropdown //
  const handleDropdown = async (token) => {
    console.log(token);
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    try {
      const { data } = await axios.get(`${window.BASE}${window.DeptId}`, {
        headers: h,
      });
      console.log(data);
      if (data) {
        setDropdown(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Lov Type //
  const handleLovType = async (token, ProductType) => {
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    // console.log(productName);
    try {
      const { data } = await axios.get(
        `${window.BASE}${window.LOVTYPE}${"ProductType"}`,
        {
          headers: h,
        }
      );
      console.log(data);
      if (data) {
        setPType(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Lov Type //
  const handleReleseLovType = async (token, RealeaseType) => {
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    // console.log(productName);
    try {
      const { data } = await axios.get(
        `${window.BASE}${window.LOVTYPE}${"RealeaseType"}`,
        {
          headers: h,
        }
      );
      console.log(data);
      if (data) {
        setRType(data);setLoader(false);
      }
    } catch (error) {
      console.log(error);setLoader(false);
    }
  };

  const handleLeavepage = async (data) => {
    console.log(data);
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    console.log(data);
    const d = {
      id,
      DepatId: parseInt(depatId),
      ProductType: productType,
      ProductName: productName,
      RealeaseType: realeaseType,
      ProdcutSpecialFeature: prodcutSpecialFeature,
      MRSId: state.id,
      investigatorId: parseInt(invis),
      rptMonth: parseInt(assM),
    };
    if (id === 0) {
      try {
        const { data } = await axios.post(`${window.BASE}${window.B5SAVE}`, d, {
          headers: h,
        });
        console.log(data);
        setStudentbtn(data);
        if (data.result === "Success") {
          alert("Succesfully Submitted");
          navigate("/B5")
          toastSuccess("Successfully Submitted");
          setId(0);
          setOpen(false);
        } else {
          // toastError(data.errorMsgs)
        }

        //   setDirect(data);
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        const { data } = await axios.post(`${window.BASE}${window.B5EDIT}`, d, {
          headers: h,
        });
        console.log(data);
        if (data.result === "Success") {
          alert("Succesfully Submitted");
          navigate("/B5")
          toastSuccess("Successfully updated");
          setId(0);
          setOpen(false);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };


  const formValidateFun=()=>{
    if(!depatId){
      setdepatIdErr(true)
      document.getElementById("depatId").focus()
    }else if(!productType){
      setproductTypeErr(true)
      document.getElementById("productType").focus()
    }else if(!productName){
      setProductNameErr(true)
      document.getElementById("productName").focus()
    }else if(!realeaseType){
      setrealeaseTypeErr(true)
      document.getElementById("realeaseType").focus()
    }else if(!prodcutSpecialFeature){
      setProdcutSpecialFeatureErr(true)
      document.getElementById("prodcutSpecialFeature").focus()
    }else{
      handleLeavepage()
    }
  }


  return (
    <div className="main-container-margin">
       <ComponentLoader isLoading={loader} />
      <div className="master-main d-flex">
        <div className="head-icon">
          <Link to="/monthyReport">
            <HomeIcon style={{ color: "white", marginLeft: 70 }} />
          </Link>
        </div>
        <div className="master-main-span">
          <span>New Variety Product (B5)</span>
        </div>
      </div>
      <div className="from-mains">
        <div className="form-control">
          <h5 style={{ margin: 20 }}>
           B5. New Variety / Technology / Farm Machinery / Software released
          </h5>

          <FormControl style={{ width: "48%", margin: 12 }} error={depatIdErr} id="depatId">
            <InputLabel id="demo-simple-select-helper-label" size="small">
              Institute Name
            </InputLabel>
            <Select
              variant="outlined"
              style={{ height: "44px" }}
              value={depatId}
              onChange={(e) => {
                setDepatId(e.target.value)
                setdepatIdErr(false)
              }}
            >
              {dropdown?.map((option, index) => {
                return (
                  <MenuItem key={index} value={option.id}>
                    {option.instituteName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

         

          <FormControl style={{ width: "48%", margin: 12 }} error={productTypeErr} id="productType">
            <InputLabel id="demo-simple-select-helper-label" size="small">
            Product Type
            </InputLabel>
            <Select
              variant="outlined"
              style={{ height: "45px" }}
              value={productType}
              onChange={(e) => {
                setProductType(e.target.value)
                setproductTypeErr(false)
              }}
            >
              {PType?.map((option, index) => {
                return (
                  <MenuItem key={index} value={option.lovName}>
                    {option.lovName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

          <TextField
            error={productNameErr}
            id="ProductName"
            label="Product Name"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={productName}
            onChange={(e) => {
              setProductName(e.target.value)
              setProductNameErr(false)
            }}
          />

          <FormControl style={{ width: "48%", margin: 12 }} error={realeaseTypeErr} id="realeaseType">
            <InputLabel id="demo-simple-select-helper-label" size="small">
              Release Type
            </InputLabel>
            <Select
              variant="outlined"
              style={{ height: "45px" }}
              value={realeaseType}
              onChange={(e) => {
                setRealeaseType(e.target.value)
                setrealeaseTypeErr(false)
              }}
            >
              {RType?.map((option, index) => {
                return (
                  <MenuItem key={index} value={option.lovName}>
                    {option.lovName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

          <TextField
            error={prodcutSpecialFeatureErr}
            id="prodcutSpecialFeature"
            label="Special Feature (Max 500 Character)"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={prodcutSpecialFeature}
            onChange={(e) => {
              setProdcutSpecialFeature(e.target.value)
              setProdcutSpecialFeatureErr(false)
            }}
          />

          <div className="from-last">
            <button
              type="submit"
              className="deactivate-buttons"
              style={{paddingTop:"5px"}}
              onClick={handleBack}
            >
              Back
            </button>
            <button type="submit" className="sbmit-buttons" style={{paddingTop:"5px"}} onClick={formValidateFun}>
            Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default B5Inside;
